import { getErrorMessage } from '@/utils/errors';
import requisitionsErrors from '@/utils/errors/Modules/requisitions';

export const createRequisitionErrorHandler = (isCreate: boolean) => {
  return (errorKey: string, result: any) => {
    const errorConfig = requisitionsErrors[errorKey];
    if (!errorConfig?.message) return null;

    const message = errorConfig.message;

    if (message.includes(' / ')) {
      const parts = message.split(' / ').map((part) => part.trim());
      const operationKeyword = isCreate
        ? ['creation', 'create']
        : ['update', 'updating'];

      const matchingParts = parts.filter((part) =>
        operationKeyword.some((keyword) => part.toLowerCase().includes(keyword))
      );

      if (matchingParts.length > 0) {
        const validationPart = matchingParts.find((part) =>
          part.toLowerCase().includes('mandatory')
        );
        return validationPart || matchingParts[0];
      }

      return isCreate ? parts[0] : parts[1] || parts[0];
    }

    return null;
  };
};

export const getRequisitionErrorMessage = (
  error: any,
  isCreate: boolean = false
) => {
  const customErrorHandler = createRequisitionErrorHandler(isCreate);
  return getErrorMessage(error, 'requisitions', customErrorHandler);
};
